export const ZONES_ENDPOINTS = {
    zones: {
        update: {
            method: 'PUT',
            url: '/zones?batch=true&mapId={mapId}',
        },
    },
};
